export const SITE_VERSION = "v27 — juin 2026";
